module.exports = __webpack_public_path__ + "assets/ef0981645698e23423e22722257fc376.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/lines/line_6.mp3
 ** module id = 56
 ** module chunks = 0
 **/